import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/aecom-colors.css'
import { localeState } from './i18n/index.js'

// Reflect the current UI language on the document root.
document.documentElement.setAttribute('lang', localeState.current)

createApp(App).use(router).mount('#app')
